
<template>
  <div class="w-100 flex pa3-ns ma2 bb b--black-30 textColor PlaylistFLex">
    <div class="flex w-100 ph2">
      <div class="image-container flex items-center justify-center ml-2">
        <img class="mw-100 h-100" :src="picture">
      </div>
      <div class="w-100 flex justify-between items-center">
        <h3 class="ml2 mt2" :class="{'title': !inArtistProfile, 'artist-profile-title': inArtistProfile}">
          {{playlist.title}} <span v-if="playlist.private" class="bg-gray br1 white f5 pa1 ttu">{{ $t('playlists.type.private') }}</span></h3>
        <div class="flex">
          <button @click="setPlaylist(playlist.tracks); playFirstTrack()" class="pa2 iconColor" title="Play">
            <font-awesome-icon class="iconColor" icon="play"/>
          </button>
          <button v-show="isMyPlaylist" @click="deletePlaylist()" class="pa2 iconColor" :title="$t('playlists.delete.title')">
            <font-awesome-icon class="iconColor" icon="trash"/>
          </button>
          <button v-show="isMyPlaylist" @click="editPlaylist()" class="pa2 iconColor" :title="$t('playlists.edit.button')">
            <font-awesome-icon class="iconColor" icon="edit"/>
          </button>
          <button v-show="!playlist.private" @click="sharePlaylist()" class="pa2 iconColor" :title="$t('playlists.share.button')">
            <font-awesome-icon class="iconColor" icon="share-alt"/>
          </button>
          <button v-if="section !== 'my-playlists'" @click="likePlaylist()" class="pa2 iconColor" :title="$t('playlists.like.button')">
            <font-awesome-icon :class="liking ? 'liked' : 'iconColor'" icon="heart"/>
          </button>
        </div>
      </div>
      <p v-show="playlist.tracks && playlist.tracks.length === 0">{{ $tc('tracks.track', 0) }}</p>
    </div>
    <div class="flex flex-column">
      <simple-tracks-list :inArtistProfile="inArtistProfile" :tracks="playlist.tracks"
                          :playlist="isMyPlaylist ? playlist : null"/>
    </div>
  </div>
</template>

<script>
  import TrackData from '@/components/tracks/TrackData'
  import consts from '@/consts'
  import {mapGetters, mapActions} from 'vuex'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import SimpleTracksList from '@/components/tracks/SimpleTracksList.vue'

  export default {
    name: 'paylist-card',
    props: {
      playlist: {
        required: true
      },
      inArtistProfile: {
        default: false
      },
      section: { default: '' }
    },
    data () {
      return {
        liking: null
      }
    },
    components: {
      TrackData,
      FontAwesomeIcon,
      SimpleTracksList
    },
    computed: {
      ...mapGetters('player', [
        'isPlaying'
      ]),
      ...mapGetters('user', [
        'myPlaylists',
        'user'
      ]),
      ...mapGetters('playlist', [
        'playlistLiked'
      ]),
      isMyPlaylist () {
        return this.user && this.playlist.user.id === this.user.id
      },
      picture () {
        if (this.playlist.picture) {
          return consts.MEDIA_BASE_URL + this.playlist.picture
        } else {
          return '/static/assets/Img_comodines_Beathey_Playlist.jpg'
        }
      }
    },
    methods: { // mapActions()
      ...mapActions('player', [
        'setPlaylist',
        'changeTrack',
        'playFirstTrack'
      ]),
      ...mapActions('playlist', [
        'delete',
        'togglePlaylistLike'
      ]),
      deletePlaylist () {
        this.$modal.show('dialog', {
          title: this.$t('playlists.delete.title'),
          text: this.$t('playlists.delete.confirm'),
          buttons: [
            {
              title: this.$t('app.yes'),
              handler: () => {
                this.delete(this.playlist.id).then(() => {
                  this.$toasted.show(this.$t('playlists.delete.success'), {type: 'success'})
                }).catch((e) => {
                  this.$toasted.show(this.error.message, {type: 'error'})
                })
                this.$modal.hide('dialog')
              }
            },
            {
              title: this.$t('app.no'),
              default: true,
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      },
      editPlaylist () {
        this.$modal.show('new-playlist-modal', {playlist: this.playlist, picturePath: this.picture})
      },
      sharePlaylist () {
        this.$modal.show('share-modal', {
          link: consts.BASE_HOST + '/services/share/playlist/' + this.playlist.id,
          title: this.playlist.title,
          // playlist de artistname
          description: '',
          playlist: this.playlist
        })
      },
      likePlaylist () {
        this.togglePlaylistLike(this.playlist.id).then(() => {
          this.liking = this.playlistLiked
        }).catch((e) => {
          console.log('error')
          console.log(e.message)
          // this.$toasted.show(this.error.message, {type: 'error'})
        })
      }
    },
    mounted () {
      this.liking = this.playlist.liked
    }
  }
</script>

<style scoped lang="scss">
  .title {
    max-width: 40vw;
    min-width: 40vw;
    width: 40vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  a.playlist-info:link, a.playlist-info:visited {
    color: #FFFFFF;
    text-decoration: none;
  }
  .PlaylistFLex{
    flex-wrap: flex;
    display: flex;
    flex-direction: column;
  }

  .artist-profile-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 15vw;
    min-width: 15vw;
    width: 15vw;
  }

  .mw-90 {
    max-width: 90%;
  }

  .image-container {
    width: 100px;
    height: 100px;
    max-width: 100px;
    max-height: 100px;
    min-width: 100px;
    min-height: 100px;
  }

  button {
    border: none;
    background: none;
    margin: 0;
    cursor: pointer;
  }

  @media screen and (max-width: 780px) {
    .image-container {
      width: 50px;
      height: 50px;
      max-width: 50px;
      max-height: 50px;
      min-width: 50px;
      min-height: 50px;
    }

    .artist-profile-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 40vw;
      min-width: 40vw;
      width: 40vw;
    }

    .title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 30vw;
      min-width: 30vw;
      width: 30vw;
    }
  }
  @media screen and (max-width: 479px) {
    .artist-profile-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 35vw;
      min-width: 35vw;
      width: 35vw;
    }
  }
  .liked {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/playlists/PlaylistCard.vue